/*
* 食べた用
*/
$(function () {

  /*
  * 食べたカウント アップ・ダウン
  */
  $(document).on('change', '.menu_ate', function (e) {

    var elem = $(this);
    $.ajaxSetup({
      headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      }
    });

    // メニューID存在チェック
    if (!$(this).is('[menu_id]')) {
      return false;
    }

    // メニューID, 加算する数取得
    let menu_id = $(this).attr('menu_id');
    let ate_count = ($(this).prop('checked')) ? 1 : -1;

    /*
    * 加算・減算
    */
    // フォーム作成
    let form = new FormData();
    form.append('menu_id', menu_id);
    form.append('ate_count', ate_count);
    // Ajax投稿(POST)
    $.ajax({
      url: '/menu_ate_calculation',
      type: 'POST',
      data: form,
      processData: false,
      contentType: false,
    }).done(function (data) {
      // OK
      // 食べた数再表示
      if ($('[menu-count-id=' + menu_id + ']').length) {
        Livewire.emitTo('menu-ate-count', 'refresh');
      }
      if ($('.member-ate-count').length) {
        Livewire.emitTo('member-ate-count', 'refresh');
      }
      // onクラス
      elem.closest('.-favorite').toggleClass('on');
    }).fail(function (data) {
      // エラー
      console.log(JSON.parse(data.responseText).errors);
    });

  });

});
